// de strings for messages/auth.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const auth: Dict = {
  "auth.continueGoogle": "Weiter mit Google",
  "auth.orEmail": "oder mit E-Mail",
  "auth.email": "E-Mail",
  "auth.emailInput": "E-Mail-Eingabe",
  "auth.emailPlaceholder": "du@beispiel.de",
  "auth.password": "Passwort",
  "auth.passwordInput": "Passwort-Eingabe",
  "auth.passwordPlaceholderNew": "Mind. 6 Zeichen",
  "auth.signUp": "Registrieren",
  "auth.logIn": "Anmelden",
  "auth.signIn": "Anmelden",
  "auth.createAccount": "Konto erstellen",
  "auth.createYourAccount": "Erstell dein Konto",
  "auth.forgotPassword": "Passwort vergessen?",
  // "Ich akzeptiere die <Nutzungsbedingungen> und die <Datenschutzerklärung>"
  "auth.agree": "Ich akzeptiere die",
  "auth.agreeJammable": "Ich akzeptiere die",
  "auth.and": "und die",
  "auth.terms": "Nutzungsbedingungen",
  "auth.privacy": "Datenschutzerklärung",
  "auth.agreeRequired":
    "Bitte akzeptiere unsere Nutzungsbedingungen und Datenschutzerklärung.",
  "auth.welcomeBack": "Willkommen zurück!",
  "auth.welcomeNew": "Willkommen bei Jammable!",
  "auth.registerError":
    "Bei der Registrierung ist ein Fehler aufgetreten. Bitte versuch es erneut.",
  "auth.backToLogin": "Zurück zur Anmeldung",

  "auth.invalidEmail": "Ungültige E-Mail",
  "auth.emailRequired": "E-Mail ist erforderlich",
  "auth.passwordMin": "Das Passwort muss mindestens 6 Zeichen haben",
  "auth.passwordRequired": "Passwort ist erforderlich",

  "auth.modal.signInTitle": "Bei Jammable anmelden",
  "auth.modal.subtitle": "Erstelle KI-Cover mit über 100.000 Stimmen.",
  "auth.modal.signUpButton": "Registrieren-Button",
  "auth.modal.signInButton": "Anmelden-Button",
  "auth.modal.haveAccount": "Schon ein Konto?",
  "auth.modal.newHere": "Neu hier?",
  "auth.modal.createAnAccount": "Konto erstellen",

  "auth.login.heading": "Willkommen zurück",
  "auth.login.blurb":
    "Deine Cover, Stimmen und Sammlungen warten genau da, wo du aufgehört hast.",
  "auth.login.noAccount": "Noch kein Konto?",

  // "Jede Stimme singt <dein Audio>"
  "auth.signup.heading": "Jede Stimme singt",
  "auth.signup.headingHighlight": "dein Audio",
  "auth.signup.blurb":
    "Über 100.000 Stimmen, alle deine Cover an einem Ort und ein Studio für Duette und Videos.",
  "auth.signup.haveAccount": "Du hast schon ein Konto?",

  "auth.forgot.title": "Passwort zurücksetzen",
  "auth.forgot.blurb":
    "Gib deine E-Mail ein und wir schicken dir einen Link für ein neues Passwort.",
  "auth.forgot.send": "Link senden",
  "auth.forgot.sentToast": "E-Mail zum Zurücksetzen gesendet!",
  "auth.forgot.sent": "Gesendet. Schau in deinen Posteingang und Spam-Ordner.",
  "auth.forgot.google": "Mit Google registriert?",
  "auth.forgot.googleAfter": "",

  "auth.reset.title": "Neues Passwort festlegen",
  "auth.reset.blurb":
    "Mindestens 6 Zeichen. Damit meldest du dich ab jetzt an.",
  "auth.reset.newPassword": "Neues Passwort",
  "auth.reset.submit": "Passwort zurücksetzen",
  "auth.reset.success": "Passwort erfolgreich zurückgesetzt!",
  "auth.reset.expired": "Link abgelaufen?",
  "auth.reset.sendNew": "Neuen anfordern",

  "auth.error.google.popup-closed-by-user":
    "Das Pop-up wurde geschlossen, bevor die Anmeldung abgeschlossen war. Bitte versuch es erneut.",
  "auth.error.google.popup-blocked":
    "Das Pop-up wurde vom Browser blockiert. Bitte erlaube Pop-ups und versuch es erneut.",
  "auth.error.google.operation-not-supported-in-this-environment":
    "Diese Anmeldemethode wird in deiner aktuellen Umgebung nicht unterstützt.",
  "auth.error.google.network-request-failed":
    "Netzwerkfehler. Bitte prüf deine Internetverbindung und versuch es erneut.",
  "auth.error.google.cancelled-popup-request":
    "Es wurden mehrere Anmeldeversuche erkannt. Bitte versuch es erneut.",
  "auth.error.google.timeout":
    "Die Anmeldung hat zu lange gedauert. Bitte prüf deine Internetverbindung und versuch es erneut.",
  "auth.error.google.account-exists-with-different-credential":
    "Es gibt schon ein Konto mit dieser E-Mail-Adresse. Bitte melde dich mit dem richtigen Anbieter an.",
  "auth.error.google.invalid-credential":
    "Die Anmeldedaten sind ungültig oder abgelaufen. Bitte versuch es erneut.",
  "auth.error.google.user-disabled":
    "Dein Konto wurde deaktiviert. Bitte wende dich an den Support.",
  "auth.error.google.user-not-found":
    "Kein Konto mit dieser E-Mail-Adresse gefunden. Versuch es erneut oder registriere dich neu.",
  "auth.error.google.wrong-password":
    "Das Passwort ist falsch. Bitte versuch es erneut.",

  "auth.error.signIn.invalid-email":
    "Die E-Mail-Adresse ist ungültig. Bitte prüf sie und versuch es erneut.",
  "auth.error.signIn.user-disabled":
    "Dein Konto wurde deaktiviert. Bitte wende dich an den Support.",
  "auth.error.signIn.user-not-found":
    "Kein Konto mit dieser E-Mail-Adresse gefunden. Versuch es erneut oder registriere dich neu.",
  "auth.error.signIn.wrong-password":
    "Das Passwort ist falsch. Bitte versuch es erneut.",
  "auth.error.signIn.too-many-requests":
    "Zu viele fehlgeschlagene Anmeldeversuche. Bitte versuch es später erneut.",

  "auth.error.signUp.email-already-in-use":
    "Diese E-Mail-Adresse wird schon von einem anderen Konto verwendet. Bitte nutze eine andere E-Mail.",
  "auth.error.signUp.invalid-email":
    "Die E-Mail-Adresse ist ungültig. Bitte prüf sie und versuch es erneut.",
  "auth.error.signUp.operation-not-allowed":
    "Neue Konten können gerade nicht erstellt werden. Bitte versuch es später erneut.",
  "auth.error.signUp.weak-password":
    "Das Passwort muss mindestens 6 Zeichen lang sein. Bitte wähl ein stärkeres Passwort.",

  "auth.error.forgot.invalid-email":
    "Bitte gib eine gültige E-Mail-Adresse ein.",
  "auth.error.forgot.user-not-found": "Kein Konto mit dieser E-Mail gefunden.",
  "auth.error.forgot.missing-android-pkg-name":
    "Ein Android-Paketname ist erforderlich.",
  "auth.error.forgot.missing-continue-uri":
    "Eine Weiterleitungs-URL ist erforderlich.",
  "auth.error.forgot.missing-ios-bundle-id":
    "Eine iOS-Bundle-ID ist erforderlich.",
  "auth.error.forgot.unauthorized-continue-uri":
    "Die angegebene Weiterleitungs-URL ist nicht erlaubt.",
  "auth.error.forgot.operation-not-allowed":
    "Das Zurücksetzen des Passworts ist für dieses Projekt nicht aktiviert.",

  "auth.error.reset.invalid-action-code":
    "Der Code ist ungültig. Bitte prüf den Link und versuch es erneut.",
  "auth.error.reset.expired-action-code":
    "Der Code ist abgelaufen. Bitte fordere eine neue E-Mail zum Zurücksetzen an.",
  "auth.error.reset.user-disabled":
    "Dieses Konto wurde deaktiviert. Bitte wende dich an den Support.",
  "auth.error.reset.user-not-found": "Kein Konto mit dieser E-Mail gefunden.",
  "auth.error.reset.weak-password":
    "Das Passwort muss mindestens 6 Zeichen haben.",
  "auth.error.reset.operation-not-allowed":
    "Das Zurücksetzen des Passworts ist für dieses Projekt nicht aktiviert.",
  "auth.seo.loginTitle": "Anmelden - Jammable",
  "auth.seo.loginDescription": "Melde dich bei deinem Jammable-Konto an.",
  "auth.seo.signupTitle": "Registrieren | Jammable",
};

export default auth;
